'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHoc = require('@mindz/react-hoc');

var _List = require('../List');

var _List2 = _interopRequireDefault(_List);

var _DropdownDefaultModule = require('./Dropdown.default.module.css');

var _DropdownDefaultModule2 = _interopRequireDefault(_DropdownDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DeleteIcon = function DeleteIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('defs', null, _react2.default.createElement('path', {
    id: 'a',
    d: 'M0 0h30v30H0z'
  })), _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('mask', {
    id: 'b',
    fill: '#fff'
  }, _react2.default.createElement('use', {
    xlinkHref: '#a'
  })), _react2.default.createElement('path', {
    fill: '#c0c2cc',
    d: 'M16.414 15l2.122 2.121a1 1 0 0 1-1.415 1.415L15 16.414l-2.121 2.122a1 1 0 0 1-1.415-1.415L13.586 15l-2.122-2.121a1 1 0 0 1 1.415-1.415L15 13.586l2.121-2.122a1 1 0 0 1 1.415 1.415L16.414 15zM15 26C8.925 26 4 21.075 4 15S8.925 4 15 4s11 4.925 11 11-4.925 11-11 11zm0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    mask: 'url(#b)'
  })));
};

DeleteIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '30',
  height: '30',
  viewBox: '0 0 30 30'
};

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _this.state = {
      isDropdownShown: false,
      options: [],
      selectedOption: null
    }, _this.toggleDropdown = function (event) {
      var _this$props = _this.props,
          stopPropagation = _this$props.stopPropagation,
          isDisabled = _this$props.isDisabled;

      if (stopPropagation) {
        event.stopPropagation();
      }

      if (!isDisabled) {
        _this.setState(function (prevState) {
          return {
            isDropdownShown: !prevState.isDropdownShown
          };
        });
      }
    }, _this.handleOutsideClick = function (event) {
      if (_this.node && !_this.node.contains(event.target)) {
        _this.setState({
          isDropdownShown: false
        });
      }
    }, _this.handleClick = function (item) {
      var handleChange = _this.props.handleChange;
      handleChange && handleChange(item.value);

      _this.setState({
        isDropdownShown: false
      });
    }, _this.onResetClick = function (event) {
      if (_this.props.stopPropagation) {
        event.stopPropagation();
      }

      _this.handleClick({
        value: null
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var children = this.props.children;
      this.setOptionsFromChildren(children);
      document.addEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var children = nextProps.children;
      this.setOptionsFromChildren(children);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          cx = _props.cx,
          placeholder = _props.placeholder,
          isToLeft = _props.isToLeft,
          alignListToLeftSide = _props.alignListToLeftSide,
          IndicatorComponent = _props.IndicatorComponent,
          headerLabel = _props.headerLabel,
          headerSecondLabel = _props.headerSecondLabel,
          error = _props.error,
          numberVisibleElements = _props.numberVisibleElements,
          isDisabled = _props.isDisabled;
      var _state = this.state,
          selectedOption = _state.selectedOption,
          isDropdownShown = _state.isDropdownShown;
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
        className: cx('root', {
          active: isDropdownShown,
          headerLabel: headerLabel,
          hasError: !!error,
          isDisabled: isDisabled
        }),
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, selectedOption && _react2.default.createElement('div', {
        className: cx('reset'),
        onClick: this.onResetClick
      }, _react2.default.createElement(DeleteIcon, {
        className: cx('reset-icon')
      })), _react2.default.createElement('div', {
        className: cx('header-label')
      }, headerLabel), _react2.default.createElement('div', {
        className: cx('header-second-label')
      }, headerSecondLabel), _react2.default.createElement('div', {
        className: cx('indicator', {
          isDefault: !IndicatorComponent,
          isSelected: selectedOption
        }),
        onClick: this.toggleDropdown
      }, !IndicatorComponent && _react2.default.createElement('span', {
        className: cx('labelText', {
          selectedOption: selectedOption
        })
      }, selectedOption ? selectedOption.label : placeholder), IndicatorComponent && _react2.default.createElement(IndicatorComponent, {
        isDropdownShown: isDropdownShown,
        selectedOption: selectedOption
      })), _react2.default.createElement('div', {
        className: cx('listHolder-cover', {
          alignListToLeftSide: alignListToLeftSide
        })
      }, _react2.default.createElement('div', {
        className: cx('listHolder', {
          isToLeft: isToLeft
        }),
        style: {
          maxHeight: numberVisibleElements * 43 + 10
        }
      }, _react2.default.createElement(_List2.default, null, this.renderOptions()))), this.renderError()));
    }
  }, {
    key: 'setOptionsFromChildren',
    value: function setOptionsFromChildren(children) {
      if (!children) {
        return;
      }

      var options = this.getOptionsFromChildren(children);
      var selectedOption = options.find(function (options) {
        return options.selected;
      });
      this.setState({
        options: options,
        selectedOption: selectedOption
      });
    }
  }, {
    key: 'getOptionsFromChildren',
    value: function getOptionsFromChildren(children) {
      return _react2.default.Children.map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            children = _child$props.children,
            selected = _child$props.selected;
        return {
          value: value,
          label: children,
          selected: selected
        };
      });
    }
  }, {
    key: 'renderOptions',
    value: function renderOptions() {
      var _this3 = this;

      var _props2 = this.props,
          cx = _props2.cx,
          stopPropagation = _props2.stopPropagation;
      var _state2 = this.state,
          options = _state2.options,
          selectedOption = _state2.selectedOption;
      return options.map(function (item) {
        var id = item.value;
        return _react2.default.createElement('div', {
          key: item.value,
          className: cx({
            active: selectedOption && selectedOption.value === id
          }),
          onClick: function onClick(event) {
            if (stopPropagation) {
              event.stopPropagation();
            }

            _this3.handleClick(item);
          }
        }, item.label);
      });
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      var _props3 = this.props,
          cx = _props3.cx,
          error = _props3.error;

      if (!error) {
        return null;
      }

      if (Array.isArray(error)) {
        return _react2.default.createElement('div', {
          className: cx('error', {
            shown: !!error
          })
        }, error[0]);
      }

      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: !!error
        })
      }, error);
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.defaultProps = {
  handleChange: function handleChange() {},
  numberVisibleElements: 5,
  stopPropagation: false
};
exports.default = (0, _reactHoc.withStyles)(_DropdownDefaultModule2.default)(Dropdown);
module.exports = exports.default;